import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, Award, ExternalLink, CheckCircle2 } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";
import { downloadPdf } from "@/components/HRPhase3Tabs";
import { toast } from "sonner";

export function MyTrainingCard() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/hr/training/mine").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items || items.length === 0) return null;
  const today = new Date().toISOString().slice(0, 10);
  const complete = async (a) => { try { await api.post(`/hr/training/mine/${a.id}/complete`); toast.success("Marked complete — your certificate is ready"); load(); } catch { toast.error("Could not mark complete"); } };
  const open = items.filter((a) => !a.completed_at), done = items.filter((a) => a.completed_at);
  return (
    <Card className="p-4 sm:p-5 space-y-3" data-testid="my-training-card">
      <div className="font-semibold flex items-center gap-2"><GraduationCap className="w-4 h-4 text-primary" /> My training {open.length > 0 && <Badge variant="outline" className="text-[10px]" data-testid="my-training-open-count">{open.length} to do</Badge>}</div>
      <div className="divide-y divide-border">
        {items.map((a) => (
          <div key={a.id} className="py-2 flex flex-wrap items-center justify-between gap-2 text-sm" data-testid={`my-course-${a.id}`}>
            <div className="min-w-0">
              <div className="font-medium">{a.course.title}{a.course.required && <Badge variant="outline" className="text-[10px] ml-1">required</Badge>}</div>
              <div className="text-xs text-muted-foreground">{a.course.description}{a.course.url && <a href={a.course.url} target="_blank" rel="noreferrer" className="ml-1 text-primary inline-flex items-center gap-0.5">open course <ExternalLink className="w-3 h-3" /></a>}</div>
              <div className={`text-xs ${a.completed_at ? "text-emerald-700" : a.due_date < today ? "text-rose-600 font-medium" : "text-muted-foreground"}`}>{a.completed_at ? `Completed ${fmtDate(a.completed_at.slice(0, 10))}` : `Due ${fmtDate(a.due_date)}${a.due_date < today ? " · overdue" : ""}`}</div>
            </div>
            {a.completed_at
              ? <Button size="sm" variant="outline" data-testid={`my-cert-${a.id}`} onClick={() => downloadPdf(`/hr/training/mine/${a.id}/certificate.pdf`, `Certificate_${a.course.title}.pdf`)}><Award className="w-4 h-4 mr-1.5" /> Certificate</Button>
              : <Button size="sm" data-testid={`my-complete-${a.id}`} onClick={() => complete(a)}><CheckCircle2 className="w-4 h-4 mr-1.5" /> Mark complete</Button>}
          </div>))}
      </div>
      {done.length > 0 && open.length === 0 && <p className="text-xs text-emerald-700">All training complete — nice work.</p>}
    </Card>
  );
}
